/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorTagsIndex from 'base/components/labrador/TagsIndex';

export const DynamicLabradorTagsIndex: typeof LabradorTagsIndex = (props) => {
    return <ErrorBoundary><LabradorTagsIndex {...props} /></ErrorBoundary>;
}
export type DynamicLabradorTagsIndexProps = PropsFromComponent<typeof LabradorTagsIndex>;
